import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, Typography } from '@mui/material';

interface FormModalProps {
  open: boolean;
  title?: string;
  children: React.ReactNode;
  onClose: () => void;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const FormModal: React.FC<FormModalProps> = ({ open, title, children, onClose, size = 'md' }) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
      disableEscapeKeyDown
      maxWidth={size}
      fullWidth
    >
      {title && <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>{title}</DialogTitle>}
      <DialogContent>
        {children}
        {/* ✅ Close Link at Bottom */}
        <Typography align="center" sx={{ mt: 2 }}>
          <Button onClick={onClose} variant="text">
            Close
          </Button>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default FormModal;
